import { AuthContextType } from '@/types/auth';

export const QUERY_REDIRECT = 'redirect';
export const QUERY_TARGET = 'target';
export const QUERY_SCROLL = 'scroll';
export const QUERY_CREATE = 'create';
export const QUERY_VALUE = 'val';
export const LOGIN_CONTENT = 'login-content';

export const INVALID_NUMBER = 'INVALID_NUMBER';
export const EMPTY_NUMBER = 'EMPTY_NUMBER';
export const MAX_ATTEMPTS_REACHED = 'MAX_ATTEMPTS_REACHED';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const SEND_FAILED = 'SEND_FAILED';
export const CAPTCHA_ERROR = 'CAPTCHA_ERROR';

export const ERROR_TRANSLATE: Record<string, string> = {
  [INVALID_NUMBER]: '请输入正确的手机号',
  [EMPTY_NUMBER]: '手机号不能为空',
  [MAX_ATTEMPTS_REACHED]: '超过了最大短信发送次数',
  [LOGIN_FAILED]: '手机号和验证码不匹配',
  [SEND_FAILED]: '验证码发送失败',
  [CAPTCHA_ERROR]: '验证失败，请重试',
};

export const DEFAULT_AUTH_CONTEXT_VALUE: AuthContextType = {
  logout: async () => false,
  user: null,
  isLogin: false,
};

export const LAST_VERIFICATION_CODE_TIME_KEY = 'lastVerificationCodeTime';
